import React from "react";
import "./App.scss";
import Application from "./components/Application/Application";

function App() {
  return <Application />;
}

export default App;
